<template>
	<v-container>
	<v-row>
		<v-col class="col-sm-4" cols="12">
			<v-text-field dense label="Rua" v-model="dados.comercial.rua" outlined></v-text-field>
        </v-col>
        <v-col class="col-sm-2" cols="12">
			<v-text-field dense label="Numero" v-model="dados.comercial.numero" outlined></v-text-field>
        </v-col>
        <v-col class="col-sm-3" cols="12">
			<v-text-field dense label="Compl" v-model="dados.comercial.complemento" outlined></v-text-field>
        </v-col>
		<v-col class="col-sm-3" cols="12">
			<v-text-field dense label="Bairro" v-model="dados.comercial.bairro" outlined></v-text-field>
        </v-col>
		<v-col class="col-sm-3" cols="12">
			<v-text-field dense label="cidade" v-model="dados.comercial.cidade" outlined></v-text-field>
        </v-col>
		<v-col class="col-sm-2" cols="12">
			<v-text-field dense label="estado" v-model="dados.comercial.estado" outlined></v-text-field>
        </v-col>
		<v-col class="col-sm-3" cols="12">
			<v-select dense :items="this.listaPaises" v-model="dados.comercial.pais" label="País" outlined></v-select>
        </v-col>
		<v-col class="col-sm-3" cols="12">
			<v-text-field dense label="Cep" v-model="dados.comercial.cep" outlined></v-text-field>
        </v-col>
		<v-col class="col-sm-3" cols="12">
			<v-text-field dense label="Fone" v-model="dados.comercial.fone" outlined></v-text-field>
        </v-col>
	</v-row>
	</v-container>
</template>
<script>
import { mapState } from 'vuex'
//import Br from '@/config/barramento.js'
	export default{
		props:['dados'],
		computed:{
			...mapState(['listaPaises']),
		},
		data(){
			return{

			}
		},
		
		created(){
		}
	}
</script>
<style scoped>
	
</style>